import httpService from "@/utils/services/http_service";

export default{
    /**
   * @author: liuxiangmin
   * date: 2020-03-09
   *  应对库
   */
  
  // 应对库记录列表
  async responseList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_solution_list',
      data
    )
  },
  
  // 应对库分类创建
  async classifyCreate(data = {}) {
    return httpService.post(
      '/api.php?do=admin_solution_cate_create',
      data
    )
  },
  
  // 应对库分类列表
  async classifyList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_solution_cate_list',
      data
    )
  },
  
  // 应对库记录创建
  async recordedCreate(data = {}) {
    return httpService.post(
      '/api.php?do=admin_solution_create',
      data
    )
  },
  
  // 应对库记录删除
  async recordedDelete(data = {}) {
    return httpService.post(
      '/api.php?do=admin_solution_delete',
      data
    )
  },
  
  // 应对库记录修改
  async recordedEdit(data = {}) {
    return httpService.post(
      '/api.php?do=admin_solution_edit',
      data
    )
  },
  
  // 应对库记录信息
  async recordedInformation(data = {}) {
    return httpService.post(
      '/api.php?do=admin_solution_list',
      data
    )
  },
  
  // 	应对库记录列表
  async recordList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_solution_list',
      data
    )
  },


  // 1.6 by-lafitewu 2020-11-13
  async categoryList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_category_list',
      data
    )
  },

  async categoryInfo(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_category_info',
      data
    )
  },

  async commentList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_comment_list',
      data
    )
  },

  async ispublishSet(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_comment_ispublish_set',
      data
    )
  },

  async istopSet(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_comment_istop_set',
      data
    )
  },

  async likeSet(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_comment_baselikecount_set',
      data
    )
  },

  // 字段管理列表
  async fieldConfigList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_field_config_list',
      data
    )
  },
  async fieldConfigAdd(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_field_config_create',
      data
    )
  },

  async fieldConfigEdit(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_field_config_edit',
      data
    )
  },

  async categoryInfoList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_category_info',
      data
    )
  },

  async categoryAdd(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_category_create',
      data
    )
  },
  async categoryEdit(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_category_edit',
      data
    )
  },

  async fieldConfigSet(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_category_field_config_set',
      data
    )
  },

  async eventCategoryList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_event_category_list',
      data
    )
  },

  async eventCategoryAdd(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_event_category_create',
      data
    )
  },

  async eventCategoryEdit(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_event_category_edit',
      data
    )
  },

  async articleList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_list',
      data
    )
  },

  async articleAdd(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_create',
      data
    )
  },

  async articleEdit(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_edit',
      data
    )
  },

  async articleDel(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_delete',
      data
    )
  },

  async articleInfo(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_info',
      data
    )
  },

  async articleOpinionList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_opinion_list',
      data
    )
  },

  async articleOpinionEdit(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_opinion_edit',
      data
    )
  },

  async articleOpinionAdd(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_opinion_create',
      data
    )
  },

  async articleOpinionDelete(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_opinion_delete',
      data
    )
  },

  async expertList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_expert_list',
      data
    )
  },

  // 下拉菜单集合
  
  // 发布人
  async memberList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_member_list',
      data
    )
  },

  async areaList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_area_list',
      data
    )
  },

  async articlePublish(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_publish',
      data
    )
  },

  // 2021.02.02 新增 事件统计模块
  async tjList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_risk_tj_list',
      data
    )
  },
  async riskList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_risk_list',
      data
    )
  },
  async tjCreate(data = {}) {
    return httpService.post(
      '/api.php?do=admin_risk_tj_create',
      data
    )
  },
  async tjDelete(data = {}) {
    return httpService.post(
      '/api.php?do=admin_risk_tj_delete',
      data
    )
  },
  async tjInfo(data = {}) {
    return httpService.post(
      '/api.php?do=admin_risk_tj_info',
      data
    )
  },
  async tjItemsCreate(data = {}) {
    return httpService.post(
      '/api.php?do=admin_risk_tj_items_create',
      data
    )
  },
  async tjItemsDelete(data = {}) {
    return httpService.post(
      '/api.php?do=admin_risk_tj_items_delete',
      data
    )
  },

  // 2021.02.23新增 - 文章来源列表
  async sourceList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_source_list',
      data
    )
  },

  // 统计库新接口
  async listDroplist(data = {}) {
    return httpService.post(
      '/api.php?do=admin_risk_tj_list_droplist',
      data
    )
  },

  // 导出接口
  async excelExport(data = {}) {
    return httpService.post(
      '/api.php?do=admin_article_list_excel_export_progress',
      data
    )
  },


}